module.exports = __webpack_public_path__ + "static/img/TAF_Renwu_mobile.587d5834.jpg";